import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'transformUnits' })
export class TransformUnitsPipe implements PipeTransform {
  /**
   * Replace units that contain ^N and replace with `<sup>N</sup>`.
   * Returns SaveHtml, so use with `innerHtml` or `outerHtml`
   *
   * Example: `<span [outerHtml]="'*10^9/L' | transformUnits"></span>`
   * @param value String with unit
   */
  transform(value: string): SafeHtml {
    // Prevent null and undefined crash
    if (!value || typeof value !== 'string') {
      return value;
    }

    if (value.indexOf('^') > -1) {
      return this.replaceToPower(value);
    }

    return value;
  }

  private replaceToPower(value: string): SafeHtml {
    // Replace *10^9/L with *10<sup>9</sup>/L
    return value.replace(/(\^[0-9]+)/g, (pow) => {
      return `<sup>${pow.replace('^', '')}</sup>`;
    });
  }
}
